<template>
    <div>
        <div class="section-subtitle"><i class="icon icon-grid"></i><span>{{ $t("app.links.budget_requests") }}<budget-forms-list :curFormSelect="'/form01-123'"/></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :hasDeltaRep="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadDeltaRep="downloadDeltaRep"
                @downloadBatchReports="downloadBatchReports"
                @downloadBatchReportsPaid="downloadBatchReportsPaid"
            ></forms-download-reprt>
        </div>
        <div class="filter-container">
            <div class="left-content">
                <p v-if="!categoryMode" class="title">{{ getCommonText('decoding') }}. {{ decodeName }}</p>
            </div>
            <div class="right-content">
                <template v-if="categoryMode">
                    <c-budget-forms-data-transfer
                        v-if="!isGkkpMode && !(progress < 100) && variantAttribute"
                        :header="header"
                        :lng="lng"
                        :getDataTransferText="getDataTransferText"
                        :getErrText="getErrText"
                        :makeToast="makeToast"
                        @reloadTable="loadCategoryData"
                    />
                    <div class="filter-actions"
                        v-if="!(progress < 100) && variantAttribute && (header.year < header.cur_year + 2)">
                        <c-budget-forms-copy-data 
                            :budgetForm="budgetForm"
                            :header="header"
                            :isLoad="isLoad"
                            :total="total"
                            @keyPress="keyPress"
                        />
                    </div>
                </template>
                <template v-else>
                    <b-button variant="light" @click="resetModal">
                        <i class="icon icon-keyboard icon-rotate-180"></i>{{ getCommonText('back_to_list') }}
                    </b-button>
                    <b-button :style="{ 'minWidth': '110px' }" v-if="variantAttribute" variant="primary" @click="$refs.formTemplate.addItem()">
                        <i class="icon icon-plus-circle"></i>{{ getCommonText('add') }}
                    </b-button>
                    <b-button
                        :style="{ 'minWidth': '110px' }" 
                        :disabled="!dataChanged || goodsAreSaving"
                        variant="success"
                        @click="prepareForSave">
                        {{ getCommonText('save') }}
                    </b-button>
                </template>
            </div>
        </div>
        
        <div v-show="categoryMode" class="table-container">
            <b-overlay :show="mainTableOverlay" rounded="sm">
            <b-table
                :fields="tableFields"
                :items="budgetForm"
                responsive="true"
                bordered
                head-variant="light"
                sticky-header="true"
                no-border-collapse
            >
                <template #top-row="data">
                    <td class="td-numbering"></td>
                    <td class="td-numbering"></td>
                    <td class="td-numbering text-center table-success">1</td>
                    <td class="td-numbering text-center table-danger">2</td>
                    <td class="td-numbering text-center table-info">3</td>
                    <td class="td-numbering text-center table-primary">4</td>
                    <td class="td-numbering text-center table-warning">5</td>
                    <td class="td-numbering text-center table-success">6</td>
                    <td class="td-numbering"></td>
                </template>
                <template #head(selection)>
                    <div class="text-center">
                        <b-form-checkbox 
                            v-model="selectAll" 
                            @change="e => setIsAllDelete(e)"
                            :value="true"
                            :unchecked-value="false" />
                    </div>
                </template>
                <template #head(more)>
                    <div class="text-center">
                        <i 
                        :title="getCommonText('del_selected')" 
                        class="icon icon-close table-all-remove"
                        @click="deleteItem(`${selectAll ? getCommonText('all_cats') : getCommonText('selected_cats')}`)"/>
                    </div>
                </template>
                <template #cell(selection)="data">
                    <b-form-checkbox 
                        v-if="!parentCodes.includes(data.item.code)"
                        v-model="data.item.itemToDelete"
                        @input="e => { if (!e) selectAll = false; }"
                        :value="true"
                        :unchecked-value="false" />
                </template>
                <template #cell(action)="data">
                    <button
                        class="table-plus"
                        v-b-modal.goods-modal @click="setCurrCatName(data.item)" 
                        v-if="!parentCodes.includes(data.item.code)"
                    >
                        <i class="icon icon-plus-circle"/>
                    </button>
                </template>
                <template #cell(name_ru)="data">
                    <div :class="{'parent-cat': !data.item.par_id, 'child-cat': data.item.par_id,}">
                        {{ data.item.name_ru }}
                    </div>
                </template>
                <template #cell(unit)="data">
                    <div>
                        {{ getCatUnitName(data.item) }}
                    </div>
                </template>
                <template #cell(amount)="data">
                    <template v-if="!parentCodes.includes(data.item.code)">
                        <div class="text-right">{{ $n(data.value) }}</div>
                    </template>
                </template>
                <template #cell(cost)="data">
                    <template v-if="!parentCodes.includes(data.item.code)">
                        <div class="text-right">{{ $n(data.value) }}</div>
                    </template>
                </template>
                <template #cell(total)="data">
                    <div class="text-right" :class="{'parent-cat': !data.item.par_id}">
                        {{ $n(data.value) }}
                    </div>
                </template>
                <template #cell(files)="data">
                    <span v-if="!parentCodes.includes(data.item.code)"
                        class="blue pointer underline"
                        @click="onAllFilesClick(data.item)"
                    >({{data.item.files ? data.item.files.length : 0}})</span>
                </template>
                <template #cell(more)="data">
                    <i class="icon icon-clear table-remove" 
                    v-if="variantAttribute && !parentCodes.includes(data.item.code)" :disabled="deletingCat || data.item.total === 0" @click="deleteItem(`${getCommonText('curr_cat')}`, data.item, data.index, true)"></i>
                </template>

                <template #bottom-row="data">
                    <td class="text-right" colspan="6">{{ getCommonText('total') }}</td>
                    <td class="text-right">{{ $n(total) }}</td>
                    <td colspan="2"></td>
                </template>
            </b-table>
            </b-overlay>
        </div>

        <template v-if="!categoryMode">
            <b-overlay :show="templateTableOverlay" rounded="sm">
                <form-03149-template1
                    ref="formTemplate"
                    :goodsData="goodsData"
                    :initialGoodsData="initialGoodsData"
                    :ensTruDict="ensTruDict"
                    :variantAttribute="variantAttribute"
                    :currCategory="currCategory"
                    :lang="lang"
                    :ifAllFieldsFilled="ifAllFieldsFilled"
                    :deleteGood="deleteGood"
                    :getUnitName="getUnitName"
                    :ensTruNamePrt="ensTruNamePrt"
                    :ensTruName="ensTruName"
                    :currUnits="currUnits"
                    :descIsLoading="descIsLoading"
                    :parNameLoading="parNameLoading"
                    :allFiles="allFiles"
                    @setTotals="setTotals"
                    @updateDatas="updateDatas"
                    @save="save"
                    @onDataChanged="onDataChanged"
                    @searchName="searchName"
                    @setIsAllDelete="setIsAllDelete"
                    @deleteSeveralGoods="deleteSeveralGoods"
                    @doublesValidationDecodes="doublesValidationDecodes"
                    :triggDownloadFile="triggDownloadFile"
                    :triggDownloadAllFiles="triggDownloadAllFiles"
                    :showFileUploadModal="showFileUploadModal"
                    :getEnstruByName="getEnstruByName"
                    :loadCurUnits="loadCurUnits"
                    :goodsAreSaving="goodsAreSaving"
                    :isDoubleDecodeExist="isDoubleDecodeExist"
                    ></form-03149-template1>
                <div class="table-add" v-if="variantAttribute">
                    <span @click="$refs.formTemplate.addItem()"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</span>
                </div>
            </b-overlay>
        </template>

        <files-updown v-if="isFilterReady" 
            ref="filesUpdown"
            v-show="categoryMode"
            :header="header"
            :variant-attribute="variantAttribute"
            :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
            :load="load"
            :showDeleteLinks="variantAttribute"
            :showDeleteAll="true"
            @getFiles="getFiles"
            @fillFilesList="fillFilesList"
            @restetFilesList="restetFilesList"
            @delelteAttachedFile="delelteAttachedFile"
            @onFilePreview="onFilePreview"
        ></files-updown>
        <modal-all-files-management
            ref="modalAllFilesManagement"
            :allFiles="allFiles"
            @triggDownloadFile="triggDownloadFile"
            @triggDownloadAllFiles="triggDownloadAllFiles"
            >
        </modal-all-files-management>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import FilesUpdown from '@/modules/budget-request/FilesUpdown';
import BudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import Form03149Template1 from "./components/budget-forms-template1.vue";
import FormsHandlerMixin from "./mixins/forms-handler-mixin";
import ModalAllFilesManagement from './components/modal-all-files-management.vue';
import CBudgetFormsCopyData from './components/budget-forms-copy-data.vue';
import FormsDownloadReprt from "./components/forms-download-reprt.vue";
import CBudgetFormsDataTransfer from './components/budget-forms-data-transfer.vue';

export default {
    name: 'Form02_149',
    components: { 
        FilesUpdown, 
        BudgetFormsList, 
        FormsDownloadReprt, 
        Form03149Template1, 
        ModalAllFilesManagement, 
        CBudgetFormsCopyData,
        CBudgetFormsDataTransfer
    },
    mixins: [FormsHandlerMixin],
    data() {
        return {
            form: {
                code: '02-149',
                name_ru: 'Расчет расходов по закупке расходных материалов',
                name_kk: 'Шығыс материалдарын сатып алу бойынша шығыстарды есептеу'
            },
            variantAttribute: null,
            budgetForm: [],
            header: null,
            dict: null,
            files: null,
            load: false,
            openDisabled: false,
            isLoad: false,
            catsSums: [],
            parentCodes: ['100', '200', '300'],
            isReportUploading: false,
        };
    },
    created() {
        this.$emit('setForm', this.form);
    },
    async mounted() {
        this.progress = 15;
    },

    watch: {
        openDisabled() {
            this.$emit('setOpenDisabled', this.openDisabled);
        },
        categoryMode() {
            this.$emit('setCategoryMode', this.categoryMode);
        },
        progress() {
            this.$emit('setProgress', this.progress);
        }
    },

    methods: {
        async loadCategoryData() {
            await this.loadDatas();
            this.catsSums.splice(0);
            this.load = true;
            try {
                const response = await fetch('/api-py/get-budget-request-form-cat/' + JSON.stringify(this.header));
                    if (response.status === 200) {
                        const values = await response.json();
                        this.catsSums = values;
                        this.setCatSums();
                    } else {
                        this.budgetForm.splice(0);
                        this.makeToast('danger', `${this.getErrText('bad_request')} loadCategoryData()`, `Error code: ${response.status}`);
                    }
            } catch (error) {
                this.budgetForm.splice(0);
                this.makeToast('danger', `${this.getErrText('bad_request')} loadCategoryData()`, error.toString());
            }
            this.load = false;
        }, // загрузка категорий

        setCatSums(sd = 'df') {
            if (this.budgetForm.length) {
                this.budgetForm.forEach(cat => {
                    if (!this.parentCodes.includes(cat.code)) {
                        const currCat = this.catsSums.find(item => item.consumable === cat.code)
                        if (currCat) {
                            this.$set(cat, 'amount', currCat.sum_amount);
                            this.$set(cat, 'cost',  parseFloat(currCat.avg_price.toFixed(2)));
                            this.$set(cat, 'total', parseFloat((currCat.sum_total / 1000).toFixed(3)));
                            this.$set(cat, 'files', this.getUnicFilesArr(currCat));
                        } else {
                            this.$set(cat, 'amount', 0);
                            this.$set(cat, 'cost', 0);
                            this.$set(cat, 'total', 0);
                            this.$set(cat, 'files', []);
                        };
                    };
                });
                this.budgetForm.forEach(cat => {
                    if (this.parentCodes.includes(cat.code)) {
                        const currCats = this.budgetForm.filter(item => item.par_id === cat.id_dict);
                        if (currCats.length) {
                            const totalSum = currCats.reduce((prev, curr) => prev + curr.total, 0);
                            this.$set(cat, 'total', totalSum);
                        } else {
                            this.$set(cat, 'total', 0);
                        }
                    }
                })
            }
        },

        deleteItem(msg, row = false, index = false) {
            if (!this.variantAttribute || this.isLoad 
                || (!row && this.budgetForm.findIndex(itm => itm.itemToDelete) === -1)) return;
            this.currCategory = row;
            this.$bvModal.msgBoxConfirm(
                this.getCommonText('del_with_decodes', {msg: msg}),
                {
                    title: this.getCommonText('confirm'),
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: this.getCommonText('yes'),
                    cancelTitle: this.getCommonText('cancel'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    if (value) {
                        if (row) {
                            this.itemUpdate(row);
                        } else {
                            const existingRowsToDel = this.budgetForm.filter(item => item.id >= 0 && item.itemToDelete);
                            if (!existingRowsToDel.length) { 
                                this.selectAll = false;
                            } else {
                                await this.deleteSeveralCats(existingRowsToDel);
                            }
                        }
                    }
                })
                .catch(error => {
                    this.makeToast('danger', this.getCommonText('on_del'), error.toString());
                });
        }, // очистить значения строки

        getFiles(data) {
            this.files = data;
        },

        getRowKey(row, keys) {
            let key = '';
            for (const k of keys) {
                key = key + this.padLeadingZeros(row[k], 3) + '.';
            }
            return key;
        }, // преобразует значения выбранных полей в код

        inputFixed(item, field, value, digit) {
            this.$set(item, field, parseFloat(parseFloat(value).toFixed(digit)));
        }, // форматирует введенное значение до digit цифр после запятой

        async itemUpdate(row) {
            await this.loadGoodsData(row);
            process.nextTick(() => {
                this.deleteGood(this.goodsData, true, true);
                for (const itm of this.catsSums) {
                    if (itm.consumable === row.code) {
                        this.$set(itm, 'sum_amount', 0);
                        this.$set(itm, 'avg_price', 0.0);
                        this.$set(itm, 'sum_total', 0.0);
                        this.$set(itm, 'all_files', '');
                        break;
                    }
                }
                this.setCatSums();
            });
        },

        keyPress: function (event, pattern) {
            const regex = new RegExp(pattern);
            const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, // вводит по заданному паттерну

        keyup13: function (event) {
            event.preventDefault();
            // Isolate the node that we're after
            const currentNode = event.target;
            // find all tab-able elements
            const allElements = document.querySelectorAll('input'); // area, object, select, [contenteditable]
            // Find the current tab index.
            const currentIndex = [...allElements].findIndex(el => currentNode.isEqualNode(el));
            // select/focus the following element
            const targetIndex = (currentIndex + 1) % allElements.length;
            if (targetIndex < allElements.length) {
                allElements[targetIndex].select();
            }
        }, // enter работает как tab

        getCatUnitName(item) {
            let unit = item.unit;
            if (item.par_id === 1 || item.par_id === 8)
                unit = item.unit === "1 пачка" ? "пачка" : item.unit === "ед (шт)" ? "штук" : item.unit;
            return unit;
        },

        async loadDatas() {
            await this.loadDict();

            const that = this;

            this.load = true;
            this.budgetForm.splice(0);
            for (const row of this.dict) {

                const item = {
                    id: 0,
                    id_dict: row.id,
                    par_id: row.par_id,
                    code: row.code,
                    unit: row.unit,
                    amount: 0,
                    cost: 0,
                    itemToDelete: false
                };
                Object.defineProperty(item, 'name_ru', {
                    get: () => {
                        return row[`name_${this.lng}`];
                    }
                });
                Object.defineProperty(item, 'unit', {
                    get: () => {
                        if (this.lng === 'kk') return row.unit_kk
                        return row.unit;
                    }
                });

                this.budgetForm.push(item);
            }
            this.load = false;
        },

        async loadDict() {
            try {
                const response = await fetch('/api-py/dictionary/consumables/');
                this.dict = await response.json();
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDict()`, error.toString());
            }
        },

        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        }, // сообщение

        noAbc: function (event) {
            const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
            const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, // вводит только цифры

        padLeadingZeros(num, size) {
            let s = String(num);
            while (s.length < size) {
                s = '0' + s;
            }
            return s;
        }, // добавляет 0-ли перед num до size-значного размера

        reSum(parent, field) {
            let sum = 0;
            this.budgetForm.forEach(row => {
                if (row.par_id === parent.id_dict) {
                    sum += parseFloat(row[field]);
                }
            });
            return parseFloat((Math.round(sum * 100) / 100).toFixed(2));
        }, // пересчет суммы

        rowClass(item, type) {
            if (!item || type !== 'row') {
                return;
            }
            if (!item.visible) {
                return 'is-hidden';
            }
        }, // задает класс 'is-hidden' заданной строке

        prepareData(val) {
            this.$set(val, 'good_type', val.consumable);
            this.$set(val, 'price', val.cost);
        },

        fillDataForSave(item, row) {
            this.$set(item, 'consumable', this.currCategory.code);
            this.$set(item, 'amount', parseFloat(row.amount));
            this.$set(item, 'cost', parseFloat(row.price));
        },

        getCodeFieldName() {
            return 'code';
        },

        calcTotalBeforeDel() {
            const newTotal = this.budgetForm.length 
                                ? this.budgetForm.reduce((acc, row) => {
                                        if (!row.itemToDelete && !this.parentCodes.includes(row.code)) {
                                            return acc + row.total
                                        } else {
                                            return acc
                                        }
                                    }, 0) 
                                : 0;
            return newTotal
        },

        calcGoodsTotalBeforeDel() {
            // при необходимости заменить в родителе
            return this.budgetForm.length ? this.budgetForm.reduce((acc, row) => !this.parentCodes.includes(row.code) ? acc + row.total : acc, 0) : 0;
        },
    },

    computed: {
        total() {
            let sum = 0;
            for (const row of this.budgetForm) {
                if ((row.par_id !== null || row.code === '400') && row.total >= 0) {
                    sum += parseFloat(row.total);
                }
            }
            return Math.ceil(sum);
        },
        decodeName() {
            const currParent = this.budgetForm.find(item => item.id_dict === this.currCategory.par_id)
            if (currParent) {
                return `${this.getFirstWordInString(currParent.name_ru)} ${this.currCategory.name_ru}`
            }
            return this.currCategory.name_ru
        },

        getFormText() {
            return this.setFormText('form_02_149.');
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: 'selection',
                        label: ' '
                    },
                    {
                        key: 'action',
                        label: ' '
                    },
                    {
                        key: 'name_ru',
                        label: this.getCommonText('name')
                    },
                    {
                        key: 'unit',
                        label: this.getUnitsText('measure')
                    },
                    {
                        key: 'amount',
                        label: this.getCommonText('count')
                    },
                    {
                        key: 'cost',
                        label: this.getCommonText('avg_cost')
                    },
                    {
                        key: 'total',
                        label: this.getCommonText('total_cost')
                    },
                    {
                        key: 'files',
                        label: this.getCommonText('files')
                    },
                    {
                        key: 'more',
                        label: ''
                    }
                ];
            };
            return [];
        }
    }
};
</script>

<style scoped>
.parent-cat {
    font-weight: bold;
}
.child-cat {
    margin-left: 1rem;
}
.table-plus {
    border: none;
}
</style>